import { onBeforeUnmount, onMounted, shallowRef, watch } from "vue";
import EasyMDE from "easymde";
import "easymde/dist/easymde.min.css";
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/solid.min.css";
import "./easymde-theme.css";

export function useMarkdownEditor(elementRef, modelRef, options = {}) {
  const editor = shallowRef(null);

  const destroyEditor = () => {
    if (editor.value) {
      editor.value.toTextArea();
      editor.value = null;
    }
  };

  const maybeInitEditor = () => {
    if (editor.value || !elementRef.value) return;

    const instance = new EasyMDE({
      element: elementRef.value,
      toolbar: [ "heading", "bold", "italic", "|", "unordered-list", "ordered-list", "|", "link" ],
      autoDownloadFontAwesome: false,
      status: false,
      spellChecker: false,
      minHeight: "110px",
      maxHeight: "160px",
      ...options,
    });

    instance.value(modelRef.value || "");
    instance.codemirror.on("change", () => {
      const value = instance.value();
      if (modelRef.value !== value) {
        modelRef.value = value;
      }
    });

    editor.value = instance;
  };

  onMounted(() => {
    maybeInitEditor();
  });

  watch(
    () => elementRef.value,
    (el) => {
      if (el) {
        maybeInitEditor();
      } else {
        destroyEditor();
      }
    },
    { flush: "post" }
  );

  watch(modelRef, (val) => {
    if (!editor.value) return;
    if (editor.value.value() !== (val || "")) {
      editor.value.value(val || "");
    }
  });

  onBeforeUnmount(() => {
    destroyEditor();
  });

  return { editor };
}
